import { useEffect, useRef, useState } from "react";
import Player from "@vimeo/player";
import { useLocation } from "react-router-dom";
import ExistingEventServices from "../../services/ExistEventServices";
import RegisterUserEvent from "../../services/EventServices";
import axios from "axios";

const LivePlayer = ({ urlStreaming }) => {
    const [timeSpent, setTimeSpent] = useState({ hours: 0, minutes: 0, seconds: 0 });
    const [isPlaying, setIsPlaying] = useState(false);
    const iframeRef = useRef(null);
    const timerRef = useRef(null);
    const location = useLocation();

    const token = sessionStorage.getItem('token');
    const idUser = sessionStorage.getItem('id_user');
    const idEvent = sessionStorage.getItem('id_event')

    useEffect(() => {
        const player = new Player(iframeRef.current);
        startTimer();

        player.on('play', () => {
            setIsPlaying(true);
            startTimer();
        });

        player.on('pause', () => {
            setIsPlaying(false);
            stopTimer();
        });

        player.on('ended', () => {
            setIsPlaying(false);
            stopTimer();
        });

        const handleBeforeUnload = (event) => {
            stopTimer();
        }

        const handleUnload = (event) => {
            stopTimer();
        }

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handleUnload);

        return () => {
            player.off('play');
            player.off('pause');
            player.off('ended');
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleUnload);
            stopTimer();
        }
    }, []);

    useEffect(() => {
        return () => {
            if (isPlaying) {
                stopTimer();
                setIsPlaying(false);
            }
        }
    }, [location]);

    const startTimer = () => {
        // Recupera el tiempo guardado del sessionStorage, si existe
        const savedTime = { hours: 0, minutes: 0, seconds: 0 };
        const totalSeconds = savedTime.hours * 3600 + savedTime.minutes * 60 + savedTime.seconds;

        // Establece el tiempo actual
        setTimeSpent({
            hours: Math.floor(totalSeconds / 3600),
            minutes: Math.floor((totalSeconds % 3600) / 60),
            seconds: totalSeconds % 60
        });

        timerRef.current = setInterval(() => {
            setTimeSpent(prevTime => {
                const totalSeconds = prevTime.hours * 3600 + prevTime.minutes * 60 + prevTime.seconds + 1;
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
                const newTime = { hours, minutes, seconds };

                // Guarda el tiempo actualizado en sessionStorage
                sessionStorage.setItem(`videoTime-${idEvent}`, JSON.stringify(newTime));
                return newTime;
            });
        }, 1000);
    };

    const stopTimer = async () => {
        clearInterval(timerRef.current);

        // Envía el tiempo acumulado a un servicio
        try {
            console.log(sessionStorage.getItem(`videoTime-${idEvent}`))

            const userData = {
                user_id: Number(idUser),
                event_id: Number(idEvent)
            };

            const timeInComponent = JSON.parse(sessionStorage.getItem(`videoTime-${idEvent}`));

            console.log("antes existing")
            await ExistingEventServices(token, userData).then(async (results) => {
                if (results['length'] === 0) {
                    if (timeInComponent.hours > 0 || timeInComponent.minutes > 0) {
                        const userData = {
                            user_id: Number(idUser),
                            event_id: idEvent,
                            duration_hour: timeInComponent.hours,
                            duration_minutes: timeInComponent.minutes,
                        };

                        await RegisterUserEvent(token, userData).then((updateResults) => {
                            console.log('inserted:', updateResults);
                        });
                    }
                } else {
                    const durationHourUser = results.data[0]['duration_hours'] || 0;
                    const durationMinuteUser = results.data[0]['duration_minutes'] || 0;

                    const userDataNew = {
                        user_id: idUser,
                        event_id: idEvent,
                        duration_hour: 0,
                        duration_minutes: 0
                    }

                    let shouldUpdate = false;

                    if (timeInComponent.hours > durationHourUser) {
                        userDataNew.duration_hour = timeInComponent.hours;
                        userDataNew.duration_minutes = durationMinuteUser;
                        shouldUpdate = true;
                    }

                    if (timeInComponent.minutes > durationMinuteUser) {
                        userDataNew.duration_hour = durationHourUser;
                        userDataNew.duration_minutes = timeInComponent.minutes;
                        shouldUpdate = true;
                    }
                    console.log(timeInComponent.minutes > durationMinuteUser, shouldUpdate)

                    if (shouldUpdate) {
                        await RegisterUserEvent(token, userDataNew).then((updateResults) => {
                            console.log('Updated:', updateResults);
                        });
                    }

                    console.log(durationHourUser, durationMinuteUser, timeInComponent)
                }
            })
        } catch (error) {
            console.error("Error sending time data:", error);
        }
    };

    return (
        <>
            <div className="relative pb-[40.25%] h-0 block md:block lg:block xl:block">
                <div style={{ padding: '40.25% 0 0 0', position: 'relative' }}>
                    <iframe
                        ref={iframeRef}
                        title={`evento-${urlStreaming}`}
                        src={urlStreaming}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    ></iframe>
                </div>
            </div>
        </>
    );
}


export default LivePlayer;